var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7937 0.771255C12.1685 0.146124 11.155 0.146124 10.5299 0.771255C9.90473 1.39639 9.90473 2.40993 10.5299 3.03506C11.155 3.66019 12.1685 3.66019 12.7937 3.03506C13.4188 2.40995 13.4188 1.39641 12.7937 0.771255Z",
    fill: "#030229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99142 0.771255C7.36629 0.146124 6.35275 0.146124 5.72761 0.771255C5.10248 1.39639 5.10248 2.40993 5.72761 3.03506C6.35275 3.66019 7.36629 3.66019 7.99142 3.03506C8.61655 2.40995 8.61655 1.39641 7.99142 0.771255Z",
    fill: "#030229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18911 0.771255C2.56398 0.146124 1.55044 0.146124 0.925304 0.771255C0.300173 1.39639 0.300173 2.40993 0.925304 3.03506C1.55044 3.66019 2.56398 3.66019 3.18911 3.03506C3.81424 2.40995 3.81424 1.39641 3.18911 0.771255Z",
    fill: "#030229"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu3);
export default __webpack_public_path__ + "static/media/Menu3.69ada164d5d91e1a5b0c4b9a8e2ba641.svg";
export { ForwardRef as ReactComponent };